import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import NoAccessMessage from './NoAccessMessage';
import MainLayout from '../layouts/MainLayout';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const location = useLocation();

  // Check if user has any roles
  const hasNoRoles = !user || !user["https://bespot.com/roles"] || user["https://bespot.com/roles"].length === 0;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (hasNoRoles) {
    return <NoAccessMessage />;
  }

  return <MainLayout>{children}</MainLayout>;
};

export default ProtectedRoute; 